//
import { RFormFields } from '@/components/reusable_components/next'

//
import RoleModel from '@/models/Role'

//
export default new RFormFields(
    {
        name: 'rut',
        type: 'text-field',
        props: {
            label: 'Rut',
        },
    }, 
    {
        name: 'names',
        type: 'text-field',
        props: {
            label: 'Nombre',
        },
    }, 
    {
        name: 'last_name1',
        type: 'text-field',
        props: {
            label: 'Primer apellido',
        },
    }, 
    {
        name: 'last_name2',
        type: 'text-field',
        props: {
            label: 'Segundo apellido',
        },
    }, 
    {
        name: 'email',
        type: 'text-field',
        props: {
            label: 'Correo',
        },
    }, 
    {
        name: 'role',
        type: 'autocomplete-model',
        props: {
            chips: true,
            itemText: 'role_name',
            itemValue: 'id',
            label: 'Rol',
            model: RoleModel,
            noObject: true,
            paramSearch: 'warehouse_roles',
        },
    }, 
    {
        name: 'is_ground_seller',
        type: 'select',
        props: {
            chips: true,
            items: [
                {
                    text: 'No',
                    value: 0,
                },
                {
                    text: 'Si',
                    value: 1,
                },
            ],
            label: 'Vendedor en terreno',
        },
    }, 
)
